import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Sparkles } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/data/content";

export default function FloatingActions({ onAI, onPlanTrip }) {
  return (
    <>
      {/* Desktop floating buttons */}
      <div className="fixed right-5 bottom-5 z-[60] flex flex-col gap-3">
        <motion.button
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 1, type: "spring", stiffness: 200 }}
          whileHover={{ scale: 1.08 }}
          onClick={onAI}
          data-testid="floating-ai-btn"
          className="relative w-16 h-16 rounded-full bg-gradient-to-br from-[#0A2342] to-[#154C79] text-white shadow-2xl border-2 border-[#C9A227]/60 flex items-center justify-center group"
          aria-label="AI Trip Planner"
        >
          <Sparkles className="w-6 h-6 text-[#C9A227]" />
          <span className="absolute right-full mr-3 whitespace-nowrap bg-[#0A2342] text-white text-xs px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
            AI Trip Planner
          </span>
          <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-[#C9A227] animate-pulse" />
        </motion.button>
      </div>

      <a
        href={`https://wa.me/${9622469097}?text=${encodeURIComponent("Hi Travwave, I'd like to plan a trip.")}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="WhatsApp"
        className="fixed left-5 bottom-5 z-[60] w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl flex items-center justify-center hover:scale-110 transition-transform"
      >
        <img
  src="/Whatsapp.png"
  alt="WhatsApp"
  className="w-11 h-11 object-contain"/>
      </a>

      {/* Mobile sticky bottom CTA */}
    </>
  );
}
